<template>
  <div :id="'comment-' + id" class="mt-3 relative" :class="{ 'z-backdrop': isOptionsModalOpen }">
    <Transition name="fade">
      <comment-options-modal v-if="isOptionsModalOpen"
                             :commentId="id"
                             :authorId="authorId"
                             :isBlocked="isBlocked"
                             :isFollowed="isFollowedByMe"
                             :isPinnedToAll="isPinnedToAll"
                             :isChildComment="nestingLevel > 1"
                             :isBetComment="isBetComment"
                             @close="hideOptionsModal"
                             @block="blockUser"
                             @unblock="unblockUser"
                             @follow="follow"
                             @unfollow="unfollow"
                             @editComment="editComment"
                             @deleteComment="deleteComment"
                             @reportComment="showReportModal"
                             @pinCommentToAll="pinCommentToAll"
                             @unpinCommentFromAll="unpinCommentFromAll">X
      </comment-options-modal>
    </Transition>
    <Transition name="fade">
          <report-modal
              v-if="isReportModalOpen"
              :id="id"
              :type="'comment'"
              :link-to-reported-item="`${window.location.origin}/?p=${postId}#comment-${id}/`"
              @close="hideReportModal"/>
        </Transition>
    <p v-if="!isCommentApproved" class="font-medium bg-[#232c3b] mx-3 p-2.5 rounded-t-zt text-zt-red text-xs xl:mx-0">W trakcie weryfikacji przez administratorów. Proszę czekać</p>
    <div class="comment xl:px-0"
         :class="[isBetComment ? 'px-3 ml-1 xl:ml-7' : 'px-4 ml-6 xl:ml-20',
         { '!mx-0' : isOutsideTD, 'opacity-50' : !isCommentApproved || isDeleted || parentDeleted }]">
      <div class="bg-zt-normal rounded-md pt-[5px] pb-[13px] relative border border-transparent transition-colors"
           :class="[
             { 'bg-zt-normal': WP.bettingTipsPage },
             isBetComment ? 'pl-2 pr-3' : 'px-3.5',
             { '!px-3 !py-2.5' : isOutsideTD, 'rounded-t-[0px]' : !isCommentApproved,  'border-zt-more border' : showSpotlight }
           ]">
        <div class="flex items-center mb-1.5">
          <a class="no-default-style" 
             :class="[
               { 'pointer-events-none': isSignedUser() },
               { 'absolute left-0.5 -top-px -translate-x-full xl:-left-2 xl:top-0': !isBetComment }
             ]"
             :href="'/typer/' + authorId"
             rel="nofollow"
             :aria-label="`Sprawdź profil: ${authorName}`"
             @click="changeUrl">
            <div class="relative">
              <img class="rounded-full object-cover mr-2 zt-hover"
                   style="overflow-clip-margin: unset;"
                   :class="[
                      { '!w-[27px] !h-[27px]' : isOutsideTD },
                      isBetComment
                       ? 'h-[29px] w-[29px]'
                       : nestingLevel > 1 ? 'w-[20px] h-[20px] xl:w-[36px] xl:h-[36px]' : 'w-[27px] h-[27px] xl:w-[50px] xl:h-[50px]']"
                   :data-src="authorAvatar" alt="Avatar" width="50" height="50" @error="handleUserAvatarError($event)">
                <div v-if="isBlocked"
                     class="opacity-40 absolute top-0 left-0 rounded-full bg-black flex items-center justify-center"
                     :class="
                       isBetComment 
                         ? 'h-[29px] w-[29px]'
                         : nestingLevel > 1 ? 'w-[20px] h-[20px] xl:w-[36px] xl:h-[36px]' : 'w-[27px] h-[27px] xl:w-[50px] xl:h-[50px]'">
                  <svg class="w-[15px] h-[15px]"
                       :class="{ 'w-[10px] h-[10px] xl:w-[20px] xl:h-[20px]': nestingLevel > 1 && !isBetComment }"
                       viewBox="0 0 214 319" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M197.131 122.59H16.2847C6.8567 122.59 0 130.305 0 138.878V302.617C0 312.048 7.71379 318.906 16.2847 318.906H197.131C206.559 318.906 213.415 311.19 213.415 302.617V138.878C213.415 130.305 205.701 122.59 197.131 122.59ZM128.563 270.898H85.7089C79.7093 270.898 75.4239 264.897 77.9951 258.896L91.7085 229.749C93.4227 226.32 92.5656 222.034 89.1373 219.462C83.1377 214.318 79.7093 207.46 79.7093 198.887C79.7093 178.313 101.994 162.882 124.278 176.598C126.849 178.313 128.563 180.027 129.42 182.599C137.991 197.173 134.563 211.746 125.135 220.319C122.564 222.891 120.85 227.177 122.564 230.606L136.277 259.754C137.991 264.04 134.563 270.898 128.563 270.898Z" fill="white"/>
                    <path d="M107.138 0C64.2836 0 30 35.1483 30 77.1547V102.016H62.5694V77.1547C62.5694 52.2938 82.2825 32.5764 107.138 32.5764C131.994 32.5764 151.707 52.2938 151.707 77.1547V102.016H184.276V77.1547C185.133 34.291 149.993 0 107.138 0Z" fill="white"/>
                  </svg>
                </div>
                <template v-if="isFollowedByMe">
                  <div v-if="isBetComment"
                       class="absolute right-1.5 bottom-0 bg-zt-main rounded-full w-3 h-3 flex justify-center items-center"
                       :class="{ 'animate-[show-up_1s_ease-in-out]': followChanged }"
                       data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-delay="500" title="Obserwujesz">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect x="0.5" y="0.5" width="19" height="19" rx="9.5" fill="#3A4B64"/>
                      <rect x="0.5" y="0.5" width="19" height="19" rx="9.5" stroke="white"/>
                      <path d="M10.1293 5.00512C9.23895 5.1766 8.5718 5.78033 8.3181 6.64715C8.26642 6.81629 8.26172 6.87971 8.26172 7.29316C8.26172 7.77943 8.28051 7.92507 8.39092 8.37375C8.64228 9.37448 9.15438 10.1544 9.76046 10.4527C10.0447 10.5913 10.2021 10.6289 10.5051 10.6289C10.9843 10.6289 11.3391 10.4762 11.7055 10.1121C12.2294 9.59529 12.5794 8.81069 12.725 7.82876C12.7791 7.46465 12.7626 6.88676 12.6898 6.63776C12.469 5.86959 11.8841 5.28466 11.1135 5.05915C10.9749 5.01921 10.8645 5.00747 10.5639 5.00277C10.3571 4.99807 10.1622 5.00042 10.1293 5.00512Z" fill="white"/>
                      <path d="M6.88779 6.89214C6.7304 6.94382 6.6012 7.05657 5.77196 7.88346C5.28099 8.37443 4.87225 8.77378 4.8652 8.77378C4.85815 8.77378 4.69841 8.62109 4.51048 8.43551C4.10174 8.03146 4.02187 7.98917 3.70474 8.00327C3.48392 8.01267 3.34532 8.06904 3.20202 8.21234C3.03993 8.37443 3 8.48719 3 8.77378C3 9.00399 3.0047 9.02748 3.06812 9.12615C3.10571 9.18487 3.42284 9.51845 3.77286 9.86847C4.49169 10.5873 4.52693 10.6108 4.82526 10.6249C5.18468 10.6437 5.09306 10.7165 6.49549 9.31643C7.18613 8.62813 7.76401 8.03381 7.79925 7.97508C7.85563 7.87877 7.86267 7.84823 7.86267 7.63446C7.86267 7.36196 7.82039 7.2445 7.66065 7.08476C7.51265 6.93677 7.3811 6.88274 7.14619 6.87804C7.03578 6.87569 6.92068 6.88039 6.88779 6.89214Z" fill="white"/>
                      <path d="M8.58047 10.6807C7.52337 11.0166 6.95723 11.2327 6.71527 11.3854C6.34881 11.6203 6.03403 12.3956 6.00349 13.1308C5.99174 13.3798 5.99644 13.4292 6.04342 13.5466C6.0998 13.6993 6.25014 13.8661 6.40519 13.9483L6.5015 14H10.495H14.4885L14.5942 13.9483C14.6529 13.9178 14.7375 13.8591 14.7821 13.8144C14.8268 13.7698 14.8714 13.7392 14.8785 13.7439C14.8878 13.7486 14.9137 13.7299 14.9372 13.6993C14.9818 13.65 14.9818 13.65 14.9372 13.6829C14.9113 13.7017 14.8972 13.7064 14.9043 13.6946C14.909 13.6805 14.9301 13.6359 14.9466 13.5936C14.9654 13.5537 14.9865 13.5184 14.9936 13.5184C15.0264 13.5184 15.017 13.004 14.9842 12.816C14.9654 12.708 14.9513 12.6117 14.9513 12.6046C14.9536 12.5976 14.9489 12.5741 14.9395 12.5553C14.8761 12.3838 14.8738 12.3603 14.9278 12.2992L14.9818 12.2382L14.9301 12.2828C14.8785 12.3251 14.8761 12.3251 14.862 12.2828C14.6976 11.8177 14.5143 11.524 14.2959 11.3854C14.0563 11.2304 13.3374 10.9555 12.5881 10.7324L12.238 10.629L12.1582 10.6924C11.841 10.9508 11.7353 11.0213 11.5286 11.1223C11.1293 11.3197 10.7933 11.3831 10.3188 11.3525C9.90772 11.3291 9.52951 11.1928 9.156 10.9321C9.06439 10.8686 8.94693 10.7747 8.89525 10.723C8.84592 10.6713 8.78719 10.6314 8.7684 10.6314C8.7496 10.6337 8.66504 10.6549 8.58047 10.6807Z" fill="white"/>
                    </svg>
                  </div>
                  <div v-else
                       class="absolute right-1 bottom-0 bg-zt-main rounded-full w-[20px] h-[20px] flex justify-center items-center"
                       :class="{ 'animate-[show-up_1s_ease-in-out]': followChanged }"
                       data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-delay="500" title="Obserwujesz">
                    <svg width="11" height="11" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8.5 3.71875C8.5 5.18575 7.31075 6.375 5.84375 6.375C4.37675 6.375 3.1875 5.18575 3.1875 3.71875C3.1875 2.25175 4.37675 1.0625 5.84375 1.0625C7.31075 1.0625 8.5 2.25175 8.5 3.71875Z" fill="white"/>
                      <path d="M3.1875 8.5C1.4271 8.5 0 9.9271 0 11.6875V14.875H8.5V8.5H3.1875Z" fill="white"/>
                      <path d="M13.8125 8.5H10.625V14.875H17V11.6875C17 9.9271 15.573 8.5 13.8125 8.5Z" fill="white"/>
                      <path d="M12.75 6.375C13.9236 6.375 14.875 5.42361 14.875 4.25C14.875 3.07639 13.9236 2.125 12.75 2.125C11.5764 2.125 10.625 3.07639 10.625 4.25C10.625 5.42361 11.5764 6.375 12.75 6.375Z" fill="white"/>
                    </svg>
                  </div>
                </template>
            </div>
          </a>
            <a :href="'/typer/' + authorId" 
               rel="nofollow"
               @click="changeUrl"
               class="no-default-style block max-w-full w-fit text-ellipsis whitespace-nowrap overflow-hidden mr-[35px]"
               :class="{ 'pointer-events-none': isSignedUser() }"
               :aria-label="`Sprawdź profil ${authorName}`">
            <div class="w-full text-sm truncate hover:underline active:underline font-medium"
                  :class="isBetComment ? 'text-white' : ''">{{ authorName }}
              <p class="inline-block font-normal text-zt-more text-xs -translate-y-px" v-if="authorId === 0">(Gość)</p>
            </div>
          </a>
          <div v-if="bookie && !isCommentsSection" @click="showOptionsModal"
               class="absolute right-3 top-2 rounded-full font-medium text-sm">
            {{bookie}}
          </div>
          <div v-else @click="showOptionsModal"
               class="absolute rounded-full w-6 h-6 top-1 right-2 flex justify-center items-center cursor-pointer zt-hover hover:bg-zt-light">
            <svg viewBox="0 0 20 20" width="30" height="30"
                 class="highlight-none fill-text rotate-90">
              <path d="M10 12c-1.105 0-2-0.895-2-2s0.895-2 2-2v0c1.105 0 2 0.895 2 2s-0.895 2-2 2v0zM10 6c-1.105 0-2-0.895-2-2s0.895-2 2-2v0c1.105 0 2 0.895 2 2s-0.895 2-2 2v0zM10 18c-1.105 0-2-0.895-2-2s0.895-2 2-2v0c1.105 0 2 0.895 2 2s-0.895 2-2 2v0z"></path>
            </svg>
          </div>
        </div>
        <div class="text-sm" :class="{ '!text-[13px] !pt-[2px]' : isOutsideTD }" >
          <span v-if="!isBlockedCommentShown && !editMode" class="comment-content max-w-full break-words leading-[21px] font-light"
                v-html="showMore ? content : shortenedContent"></span>
          <div v-else-if="editMode">
            <div class="relative">
              <textarea 
                rows="1" 
                class="min-h-[30px] py-2.5" 
                v-model="editContent"
                ref="editTextarea"
                @keyup="isMentionEnabled ? handleEditMentionKeyup($event) : null"
                @keydown="isMentionEnabled && mentionSuggestions.isVisible ? handleMentionKeydown($event) : null"
                @input="isMentionEnabled ? handleEditMentionInput($event) : null"
              ></textarea>
              <UserMentionSuggestions
                v-if="isMentionEnabled && mentionSuggestions.isVisible && mentionSuggestions.isEditMode"
                :bet-id="betId"
                :search-query="mentionSuggestions.searchQuery"
                @select-user="handleEditMentionSelect"
                @close="closeMentionSuggestions"
                ref="editMentionSuggestions"
              />
            </div>
            <div class="flex justify-end gap-x-2 mt-1">
              <button class="zt-hover zt-button bg-zt-light/35 border border-zt-light" @click="cancelEdit">Anuluj</button>
              <button class="zt-hover zt-button" @click="saveEditComment">Zapisz</button>
            </div>
          </div>

          <span v-else class="underline text-zt-more zt-hover cursor-pointer" @click="showBlockedComment">
            Wyświetl komentarz
          </span>
          <div v-if="!showMore && shortenedContent.length < content.length" class="inline w-full h-0">
            <span class="underline font-regular text-[14px] text-zt-more cursor-pointer zt-hover whitespace-nowrap" @click="showAll">
              Rozwiń
            </span>
          </div>
        </div>
        <Transition name="fade">
          <div v-if="likeCount > 0 && (!bookie || isCommentsSection)"
               class="text-sm bottom-0 translate-y-1/2 duration-500 absolute bg-[#344762] min-w-[25px] h-[18px]
                 flex flex-nowrap items-center justify-between gap-x-1 py-px pl-px pr-1.5 transition-colors rounded-xl tabular-nums
                 right-3 xl:right-7 ">
            <svg class="w-4 h-4 basis-4 overflow-hidden rounded-full transition-colors duration-[1s] shrink-0 grow-0 stroke-transparent fill-white"
                 :class="{ 'animate-[like-animation_1s]': animate }" viewBox="0 0 16 16"  version="1.1" xmlns="http://www.w3.org/2000/svg">
              <circle cx="8" cy="8" r="8" fill="#419AD4" stroke-width="0"/>
              <path d="M8.02052 3.29201C7.97899 3.31156 7.953 3.35321 7.95412 3.39843C7.97027 4.05479 7.97835 4.43525 7.97835 4.53979V4.83551L7.92797 4.93901C7.8714 5.05524 7.84218 5.10345 7.42778 5.76467C7.26549 6.02362 7.051 6.37847 6.95113 6.55326C6.8321 6.76157 6.7698 6.99652 6.77024 7.23539L6.77615 10.4265C6.77687 10.8176 7.09988 11.1342 7.49809 11.1342H11.0513L11.1808 11.0718C11.4717 10.9316 11.6853 10.6054 11.6868 10.2988C11.6874 10.1806 11.6836 10.1653 11.6225 10.0417C11.5868 9.96934 11.5594 9.90908 11.5617 9.90775C11.564 9.90642 11.631 9.87712 11.7107 9.84266C12.053 9.69455 12.2544 9.45916 12.269 9.19021C12.2767 9.04821 12.2428 8.95009 12.1285 8.78295C12.0824 8.71557 12.0447 8.65649 12.0447 8.65164C12.0447 8.6468 12.0558 8.64284 12.0695 8.64284C12.0831 8.64284 12.1498 8.61458 12.2177 8.58004C12.5277 8.4223 12.7052 8.12287 12.6549 7.84249C12.6214 7.65568 12.5212 7.50716 12.2986 7.31427L12.2256 7.25107L12.3095 7.16301C12.4176 7.04942 12.4832 6.95595 12.5262 6.85412C12.5546 6.78718 12.5609 6.74432 12.5612 6.6166C12.5617 6.37306 12.5044 6.20983 12.3687 6.06876C12.2778 5.97426 12.1765 5.91277 12.0332 5.86522L11.9155 5.82615C10.2991 5.81738 9.49093 5.81105 9.49096 5.80717C9.49102 5.80134 9.50466 5.6868 9.52127 5.55262C9.55932 5.24537 9.56347 4.6846 9.52919 4.48065C9.43159 3.89988 9.1171 3.44498 8.70331 3.28599C8.5997 3.24619 8.56565 3.2406 8.40398 3.23694C8.30366 3.23467 8.19168 3.2389 8.15517 3.24635C8.11864 3.25379 8.05805 3.27434 8.02052 3.29201ZM4.65918 6.73157H6.03585C6.1572 6.73157 6.25557 6.82819 6.25557 6.94737V11.2209C6.25557 11.3401 6.1572 11.4367 6.03585 11.4367H4.65918C4.53783 11.4367 4.43945 11.3401 4.43945 11.2209V6.94737C4.43945 6.82819 4.53783 6.73157 4.65918 6.73157Z" stroke-width="0.5"/>
            </svg>
            <div class="grow shrink-0 text-center basis-2"
                 :style="{ 'width': 9 * likeCount.toString().length + 'px' }">{{ likeCount }}</div>
          </div>
        </Transition>
      </div>
      <div class="flex items-center pb-1.5 pl-1.5 pt-2 text-xs" :class="isBetComment ? 'gap-x-2' : 'gap-x-2.5'">
        <span v-if="!bookie || isCommentsSection" @click="toggleLike"
              class="shrink-0 grow-0 w-fit w-[60px] text-center whitespace-nowrap select-none "
              :class="[{ 'text-[#419AD4]': isLikedByMe,
                'text-zt-more': isBetComment && !isLikedByMe },
                isCommentApproved ? 'cursor-pointer zt-hover' : '']">Lubię to!</span>
        <span v-if="nestingLevel <= 2 && (!bookie || isCommentsSection) && !(nestingLevel === 2 && isOutsideTD)"
              :class="isBetComment ? 'font-thin' : 'font-semibold'">•</span>
        <button v-if="(nestingLevel <= 2 && !isOutsideTD) || (nestingLevel === 1 && isOutsideTD)" class="cursor-default"
                :class="{ 'text-zt-more': isBetComment, 'zt-hover cursor-pointer' : isCommentApproved }"
                :disabled="!isCommentApproved"
                @click="toggleAnswer">Odpowiedz</button>
        <span v-if="!(nestingLevel === 3 && bookie && !isCommentsSection)"
              :class="isBetComment ? 'font-thin' : 'font-semibold'">•</span>
        <span class="pl-0.5"
              :class="isBetComment ? 'text-zt-more text-xs' : 'text-[#B5B5B5] text-[10px]'"
              data-bs-trigger="click" data-bs-toggle="tooltip" data-bs-placement="bottom"
              @click="hideTooltip"
              :title="absDate">
          {{ parsedDate }}
        </span>
        <span v-if="isPinnedToAll" class="font-thin">•</span>
        <div v-if="isPinnedToAll" class="flex items-center">
          <div class="flex justify-center items-center" :class="{ 'bg-[#344762] rounded-lg w-[28px] h-4': window.size.mobile }">
            <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7.51792 11.0078L9.80966 11.8122L8.538 15.4351L9.11093 15.6362L10.3826 12.0133L12.6743 12.8177C12.826 12.8709 13.0081 12.7834 13.0614 12.6317L13.3394 11.8397C13.5405 11.2668 13.2738 10.6243 12.7414 10.3618L13.0875 8.83657C13.118 8.69585 13.0414 8.53649 12.8897 8.48325L10.0756 7.4955C9.92396 7.44226 9.77051 7.50197 9.70043 7.64771L9.02325 9.03775C8.44351 8.90997 7.83977 9.22802 7.63276 9.81781L7.35476 10.6098C7.27285 10.7893 7.36626 10.9545 7.51792 11.0078Z" fill="#93A3BA"/>
              <path d="M9.73752 6.94244L13.4785 8.2555C13.6301 8.30874 13.8122 8.22125 13.8655 8.06959L14.0784 7.46295C14.2558 6.95742 13.9824 6.38827 13.4769 6.21083L11.0167 5.34728C10.5111 5.16984 9.94198 5.44325 9.76453 5.94878L9.5516 6.55542C9.49246 6.72393 9.58586 6.8892 9.73752 6.94244Z" fill="#93A3BA"/>
            </svg>
          </div>
          <span v-if="window.size.desktop" class="text-zt-more text-[12px] font-light -ml-[2px]">Przypięte</span>
        </div>
      </div>
      <Transition name="slide">
        <div v-show="isAnswerOpen">
          <div v-if="isLoggedIn() && !isUserBlocking"
               :class="{ 'bg-zt-normal rounded-zt px-2.5 py-2.5' : isOutsideTD }"
               class="flex relative py-2 justify-center items-center gap-x-2">
            <img
                :class="{ '!w-[27px] !h-[27px]' : isOutsideTD }"
                style="overflow-clip-margin: unset;"
                class="rounded-full object-cover w-[30px] h-[30px] min-w-[30px]" height="30" width="30" alt="Avatar"
                :src="WP.user.avatar" @error="handleUserAvatarError($event)"/>
            <textarea :placeholder="isOutsideTD ? 'Wpisz treść komentarza' : 'Napisz komentarz...'" ref="textarea" rows="1" 
              @focus="resize" 
              @keyup="handleTextareaKeyup"
              @keydown="handleTextareaKeydown"
              @input="handleTextareaInput"
              v-model="answerContent"
              class="py-1.5 pl-2 !text-text self-stretch overflow-hidden
                     resize-none focus:outline-none !pr-10" :class="{ 'font-light': isBetComment, '!pr-9 xl:!pr-8' : !isBetComment }"></textarea>
            <div v-if="isBetComment"
                 :class="{ 'right-5 xl:right-1' : isOutsideTD }"
                 class="absolute top-0 h-full flex items-center right-3 xl:right-0">
            </div>
            <UserMentionSuggestions
              v-if="isMentionEnabled && mentionSuggestions.isVisible && !mentionSuggestions.isEditMode"
              :bet-id="betId"
              is-visible
              :search-query="mentionSuggestions.searchQuery"
              :position="mentionSuggestions.position"
              @select-user="handleMentionSelect"
              @close="closeMentionSuggestions"
              ref="mentionSuggestions"
            />
            <div v-else
                 class="flex absolute right-2 bottom-px h-full py-2 items-center">
              <button class="block" @click="addComment">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M13.7267 7.55476L2.72665 2.05476C2.64044 2.01164 2.5436 1.99437 2.44779 2.00501C2.35198 2.01566 2.2613 2.05377 2.18665 2.11476C2.11536 2.17451 2.06215 2.25295 2.03301 2.34128C2.00386 2.42961 1.99993 2.52432 2.02165 2.61476L3.50165 7.99976L2.00165 13.3698C1.98126 13.4453 1.97888 13.5245 1.9947 13.6012C2.01052 13.6778 2.0441 13.7496 2.09273 13.8109C2.14136 13.8722 2.2037 13.9212 2.27472 13.954C2.34574 13.9868 2.42347 14.0025 2.50165 13.9998C2.57992 13.9993 2.65699 13.9805 2.72665 13.9448L13.7267 8.44476C13.8086 8.4028 13.8773 8.33905 13.9253 8.26054C13.9733 8.18202 13.9987 8.09178 13.9987 7.99976C13.9987 7.90774 13.9733 7.8175 13.9253 7.73898C13.8773 7.66047 13.8086 7.59672 13.7267 7.55476ZM3.27665 12.5548L4.38165 8.49976H9.00165V7.49976H4.38165L3.27665 3.44476L12.3817 7.99976L3.27665 12.5548Z" fill="#93A3BA"/>
                </svg>
              </button>
            </div>
          </div>
          <div v-else-if="isUserBlocking" class="flex p-2 justify-center items-center gap-x-2">
            <svg class="w-[30px] h-[30px] min-w-[30px]" width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="15" cy="15" r="15" fill="#CB1F28" />
              <g clip-path="url(#clip0_1803_900)">
                <path d="M7.29289 21.2929C6.90237 21.6834 6.90237 22.3166 7.29289 22.7071C7.68342 23.0976 8.31658 23.0976 8.70711 22.7071L7.29289 21.2929ZM22.7071 8.70711C23.0976 8.31658 23.0976 7.68342 22.7071 7.29289C22.3166 6.90237 21.6834 6.90237 21.2929 7.29289L22.7071 8.70711ZM8.70711 22.7071L22.7071 8.70711L21.2929 7.29289L7.29289 21.2929L8.70711 22.7071Z" fill="white" />
                <path d="M8.70711 7.29289C8.31658 6.90237 7.68342 6.90237 7.29289 7.29289C6.90237 7.68342 6.90237 8.31658 7.29289 8.70711L8.70711 7.29289ZM21.2929 22.7071C21.6834 23.0976 22.3166 23.0976 22.7071 22.7071C23.0976 22.3166 23.0976 21.6834 22.7071 21.2929L21.2929 22.7071ZM7.29289 8.70711L21.2929 22.7071L22.7071 21.2929L8.70711 7.29289L7.29289 8.70711Z" fill="white" />
              </g>
              <defs>
                <clipPath id="clip0_1803_900">
                  <rect width="14" height="14" fill="white" transform="translate(8 8)" />
                </clipPath>
              </defs>
            </svg>
            <div class="!bg-zt-light/35 text-xs text-zt-more overflow-hidden resize-none self-stretch w-full focus:outline-none"
                 :class="isBetComment
                   ? 'py-1.5 pl-2 pr-9 rounded-lg bg-zt-normal'
                   : 'font-light py-2 pl-3 pr-10 rounded-zt bg-zt-light/35 border border-zt-light textarea-comments'">
              Nie możesz dodawać komentarzy do postów tego użytkownika, ponieważ cię zablokował
            </div>
          </div>
          <div v-else-if="!isLoggedIn() && isOutsideTD">
            <div class=" bg-zt-normal rounded-zt ">
              <div ref="textareaWrapper" class="flex min-h-[47px] p-2.5 mt-2.5 relative gap-x-2.5">
                <textarea
                    placeholder="Wpisz treść komentarza"
                    type="text"
                    rows="1"
                    v-model="answerContent"
                    required
                    ref="textarea"
                    @keyup="resize();"
                    class="w-full !pr-10 min-h-[27px] pt-[5px] resize-none" />
                <svg xmlns="http://www.w3.org/2000/svg"
                     @click="addComment"
                     class="cursor-pointer zt-hover absolute right-5 top-1/2 -translate-y-1/2" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M13.7283 7.55368L2.74139 2.05281C2.65528 2.00969 2.55856 1.99241 2.46286 2.00306C2.36717 2.01371 2.27659 2.05182 2.20204 2.11282C2.13083 2.17258 2.07769 2.25104 2.04857 2.33938C2.01946 2.42772 2.01553 2.52245 2.03723 2.6129L3.51547 7.99875L2.01726 13.3696C1.99689 13.4451 1.99452 13.5244 2.01032 13.601C2.02612 13.6777 2.05965 13.7495 2.10823 13.8108C2.1568 13.8721 2.21906 13.9211 2.29 13.9539C2.36093 13.9867 2.43857 14.0024 2.51666 13.9997C2.59484 13.9992 2.67181 13.9804 2.74139 13.9447L13.7283 8.44382C13.8101 8.40186 13.8788 8.3381 13.9267 8.25957C13.9746 8.18104 14 8.09079 14 7.99875C14 7.90672 13.9746 7.81646 13.9267 7.73794C13.8788 7.65941 13.8101 7.59565 13.7283 7.55368ZM3.29074 12.5545L4.39442 8.49883H9.00893V7.49868H4.39442L3.29074 3.44303L12.3849 7.99875L3.29074 12.5545Z" fill="#93A3BA"/>
                </svg>
              </div>
              <div class="mx-2.5 pt-2.5 border-t border-zt-light">
                <div class=" justify-between items-center pb-2.5 xl:flex">
                <textarea class="w-full !pr-10 min-h-[27px] pt-[5px] resize-none xl:max-w-[324px]"
                          :class="{'outline outline-1 outline-zt-red': commentSignatureError}"
                          rows="1"
                          placeholder="Podpis"
                          v-model="signature"
                          required />
                  <p v-if="commentSignatureError && window.size.mobile"
                     class="inline-block pb-2.5 text-xs xl:text-sm text-zt-red right-5 bottom-[22px] xl:bottom-5 firefox-bottom-signature">{{ commentSignatureErrorMessage }}</p>
                  <p class="text-xs font-light text-center pt-1 xl:pt-0">
                    Lub
                    <span @click="openLoginModal"
                          class="text-zt-more underline cursor-pointer zt-hover">Zaloguj się</span>
                  </p>
                </div>
              </div>
              <p v-if="commentSignatureError && window.size.desktop"
                 class="inline-block px-2.5 pb-2.5 text-xs xl:text-sm text-zt-red right-5 bottom-[22px] xl:bottom-5 firefox-bottom-signature">{{ commentSignatureErrorMessage }}</p>
            </div>
          </div>
          <div v-else
               :class="{ 'bg-zt-normal rounded-zt px-2.5 py-2.5' : isOutsideTD }"
               class="flex relative py-2 justify-center items-center gap-x-2">
            <img
              :class="{ '!w-[27px] !h-[27px]' : isOutsideTD }"
              style="overflow-clip-margin: unset;"
              class="rounded-full object-cover w-[30px] h-[30px] min-w-[30px]" height="30" width="30" alt="Avatar"
              :src="'/wp-content/themes/zawodtyper/assets/images/default-avatar.webp'" @error="handleUserAvatarError($event)"/>
            <div class="cursor-pointer self-stretch w-full h-[28px]"
                 @click="countClicks('Pokazywanie NAPISZ KOM również gościom (tylko kliki gości)'); openLoginModal();">
              <textarea class="py-1.5 pl-2 !text-text self-stretch overflow-hidden resize-none focus:outline-none
                               !pr-10 pointer-events-none"
                        :class="{ 'font-light': isBetComment, '!pr-9 xl:!pr-8' : !isBetComment }"
                        placeholder="Zaloguj się, aby dodać komentarz" ref="textarea" rows="1"
                        disabled></textarea>
            </div>
            <div v-if="isBetComment"
                 :class="{ 'right-5 xl:right-1' : isOutsideTD }"
                 class="absolute top-0 h-full flex items-center right-3 xl:right-0">
              <button class="zt-hover xl:h-[calc(100%-20px)] xl:px-4" aria-label="Dodaj komentarz"
                      @click="countClicks('Pokazywanie NAPISZ KOM również gościom (tylko kliki gości)'); openLoginModal();">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M13.7267 7.55476L2.72665 2.05476C2.64044 2.01164 2.5436 1.99437 2.44779 2.00501C2.35198 2.01566 2.2613 2.05377 2.18665 2.11476C2.11536 2.17451 2.06215 2.25295 2.03301 2.34128C2.00386 2.42961 1.99993 2.52432 2.02165 2.61476L3.50165 7.99976L2.00165 13.3698C1.98126 13.4453 1.97888 13.5245 1.9947 13.6012C2.01052 13.6778 2.0441 13.7496 2.09273 13.8109C2.14136 13.8722 2.2037 13.9212 2.27472 13.954C2.34574 13.9868 2.42347 14.0025 2.50165 13.9998C2.57992 13.9993 2.65699 13.9805 2.72665 13.9448L13.7267 8.44476C13.8086 8.4028 13.8773 8.33905 13.9253 8.26054C13.9733 8.18202 13.9987 8.09178 13.9987 7.99976C13.9987 7.90774 13.9733 7.8175 13.9253 7.73898C13.8773 7.66047 13.8086 7.59672 13.7267 7.55476ZM3.27665 12.5548L4.38165 8.49976H9.00165V7.49976H4.38165L3.27665 3.44476L12.3817 7.99976L3.27665 12.5548Z" fill="#93A3BA"/>
                </svg>
              </button>
            </div>
            <div v-else
                 class="flex absolute right-2 top-0 h-full py-2 items-center before:block before:w-0.5 before:h-[calc(100%_-_16px)]
                 before:bg-zt-main before:absolute before:-left-2">
              <button class="block"
                      @click="countClicks('Pokazywanie NAPISZ KOM również gościom (tylko kliki gości)'); openLoginModal();">
                <svg width="20" height="20" viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0.920599 10.5L10.541 6L0.920599 1.5L0.916016 5L7.79101 6L0.916016 7L0.920599 10.5Z" fill="white" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </Transition>
    </div>
    <div class="ml-6" :class="[isBetComment ? 'xl:ml-7' : 'xl:ml-20', {  '!ml-[39px] !xl:ml-[51px]' : isOutsideTD }]">
      <TransitionGroup name="fade">
        <comment v-for="comment in commentsToShow"
                 :key="comment.comment_id"
                 :data="comment"
                 :bookie="comment.bookie"
                 :bet-id="betId"
                 :isBlocked="betAuthorBlocked(comment.author_id, blockedUserIds)"
                 :isCommentsSection="isCommentsSection"
                 :isBetComment="isBetComment"
                 :is-comment-approved="comment.comment_approved === '1'"
                 :blockedUserIds="blockedUserIds"
                 :parent-deleted="isDeleted"
                 :is-outside-t-d="isOutsideTD"
                 @blockUser="(commentAuthorId) => $emit('blockUser', commentAuthorId)"
                 @unblockUser="(commentAuthorId) => $emit('unblockUser', commentAuthorId)"/>
      </TransitionGroup>
      <div v-if="!showAllComments && comments.length - commentsToShow.length > 0" 
           class="zt-hover flex items-center gap-2 mt-1"
           :class="[isBetComment ? 'ml-5 xl:ml-8' : 'ml-11 xl:ml-20', { 'xl:!ml-1' : isOutsideTD }]">
        <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7.9971 9.00136L10.996 9.00136L10.996 11.0017C10.997 11.1991 11.0564 11.3919 11.1667 11.5556C11.277 11.7194 11.4332 11.8468 11.6158 11.9218C11.7978 11.9984 11.9985 12.0193 12.1924 11.9819C12.3863 11.9446 12.5648 11.8505 12.7054 11.7118L15.7043 8.71132C15.798 8.61834 15.8724 8.50772 15.9231 8.38584C15.9739 8.26397 16 8.13324 16 8.00121C16 7.86918 15.9739 7.73845 15.9231 7.61657C15.8724 7.4947 15.798 7.38408 15.7043 7.2911L12.7054 4.29065C12.612 4.19795 12.5012 4.12462 12.3794 4.07484C12.2576 4.02507 12.1272 3.99984 11.9957 4.0006C11.8645 3.99722 11.7344 4.02463 11.6158 4.08062C11.4332 4.15565 11.277 4.28307 11.1667 4.44681C11.0564 4.61056 10.997 4.8033 10.996 5.00076L10.996 7.00106L7.9971 7.00106C6.40638 7.00106 4.88081 6.36882 3.756 5.24343C2.63119 4.11805 1.99928 2.59169 1.99928 1.00015C1.99928 0.734895 1.89396 0.480501 1.70649 0.292937C1.51902 0.105372 1.26476 3.34521e-07 0.999638 3.57699e-07C0.734517 3.80877e-07 0.480255 0.105372 0.292787 0.292937C0.105318 0.480502 -3.11525e-08 0.734895 -7.96314e-09 1.00015C1.77553e-07 3.1222 0.84255 5.15734 2.3423 6.65786C3.84204 8.15838 5.87614 9.00136 7.9971 9.00136Z" fill="white"/>
        </svg>
        <button class="underline text-xs" @click="showAllComments = true">
          Zobacz {{ comments.length - commentsToShow.length }} {{ inflectNumber(comments.length - commentsToShow.length, ['odpowiedź', 'odpowiedzi', 'odpowiedzi']) }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import CommentOptionsModal from './modals/CommentOptionsModal.vue';
import ReportModal from './modals/ReportModal.vue';
import UserMentionSuggestions from './UserMentionSuggestions.vue';
import comment_mixin from '../mixins/comment_mixin.js';
import utils_mixin from '../mixins/utils_mixin';
import { Notice } from '../../assets/js/Notice';
import { useUserStore } from '../stores/UserStore';
import emoji_mixin from '../mixins/emoji_mixin';
import { useMentions } from '../composables/useMentions.js';
import {isPhraseOffensive} from "../../assets/js/frontend-black-list";

export default {
  name: 'Comment',
  emits: ['blockUser', 'unblockUser', 'followPost'],
  props: {
    data: Object,
    bookie: String,
    isBlocked: Boolean,
    isBlocking: Boolean,
	  isBetExplicitlyMuted: Boolean,
    isBetComment: Boolean,
    isCommentsSection: Boolean,
    blockedUserIds: Array,
    blockingUserIds: Array,
	  isBetFollowed: Boolean,
    isOutsideTD: {
      type: Boolean,
      default: false
    },
    isCommentApproved: {
      type: String,
      default: '1'
    },
    parentDeleted: {
      type: Boolean,
      default: false
    },
    betId: {
      type: Number,
      default: null
    }
  },
  inject: ['WP'],
  mixins: [comment_mixin, utils_mixin, emoji_mixin],
  components: {
    CommentOptionsModal,
    ReportModal,
    UserMentionSuggestions
  },
  setup() {
    const userStore = useUserStore();
    const mentions = useMentions();
    return { userStore, mentions };
  },
  data() {
    this.commentSignatureErrorMessages = {
      'offensive_language': 'Nazwa użytkownika jest niedozwolona.',
      'too_short_signature': 'Minimalna liczba znaków to 3.',
      'too_long_signature': 'Maksymalna liczba znaków to 30.',
    };
    return {
      comments: this.data.answers ?? [],
      answerContent: '',
      answerMentions: [],
      isAnswerOpen: false,
      isOptionsModalOpen: false,
      followChanged: false,
      parsedDate: null,
      showAllComments: false,
      lastCommentTimestamp: 0,
      absDate: null,
      showMore: false,
      animate: false,
      isBlockedCommentShown: false,
      isReportModalOpen: false,
      likeCount: this.data.like_count,
      editMode: false,
      editMentions: [],
      editContent: '',
      signature: '',
      commentSignatureError: false,
      commentSignatureErrorMessage: '',
      isDeleted: false,
      showSpotlight: false,
      mentionSuggestions: {
        isVisible: false,
        searchQuery: '',
        mentionInfo: null,
        isEditMode: false
      }
    };
  },
  computed: {
		type() {
			return {
				parent: this.$parent?.$parent?.$options.name,
				grandparent: this.$parent?.$parent?.$parent?.$parent?.$options.name
			}
		},
    id() {
      return Number(this.data.comment_id);
    },
    parentId() {
      return Number(this.data.parent_id);
    },
    postId() {
      return Number(this.data.post_id);
    },
    authorId() {
      return Number(this.data.author_id);
    },
    authorName() {
      return this.data.author_name;
    },
    authorAvatar() {
      return this.data.author_avatar;
    },
    authorRole() {
      return this.data.author_role;
    },
    date() {
      return this.data.date;
    },
    content() {
      return this.sanitizeHTML(this.data.content, 'br');
    },
    isLikedByMe() {
      if (this.likeCount === 0) return false;

      return this.userStore.isCommentLiked(this.id);
    },
    isFollowedByMe() {
      return this.userStore.isUserFollowed(this.authorId);
    },
    isPinnedToAll() {
      return !!Number(this.data.pinned_to_all);
    },
    commentsToShow() {
      if (this.showAllComments) {
        return this.comments.sort((a, b) => {
                 if (a.pinned_to_all !== b.pinned_to_all) {
                   return b.pinned_to_all - a.pinned_to_all;
                 }
               });
      } else if (this.nestingLevel !== 2){
        return this.comments.sort((a, b) => {
                 if (a.pinned_to_all !== b.pinned_to_all) {
                   return b.pinned_to_all - a.pinned_to_all;
                 }
               }).slice(0, 1);
      } else {
        return [];
      }
    },
    isUserBlocking() {
      return this.isBlocking;
    },
    nestingLevel() {
      let parentName = this.$parent?.$parent?.$options.name;
      let grandparentName = this.$parent?.$parent?.$parent?.$parent?.$options.name;
      if (parentName === 'Bets' || parentName === 'BetItem' || parentName === 'BetAd' || parentName === 'BetDiscussion' || parentName === 'Comments'|| parentName === 'CommentsBonuses') {
        return 1;
      } else if (grandparentName === 'Bets' || grandparentName === 'Comments'|| grandparentName === 'CommentsBonuses') {
        return 2;
      } else {
        return 3;
      }
    },
    shortenedContent() {
      if (this.WP.bettingTipsPage) {
        if (window.size.mobile) {
          return this.content.length > 204 ? this.content.slice(0, 200) + '... ' : this.content;
        } else {
          return this.content.length > 265 ? this.content.slice(0, 260) + '... ' : this.content;
        }
      } else {
        if (window.size.mobile) {
          return this.content.length > 324 ? this.content.slice(0, 320) + '... ' : this.content;
        } else {
          return this.content.length > 404 ? this.content.slice(0, 400) + '... ' : this.content;
        }
      }
    },
    isMentionEnabled() {
      return this.WP?.bettingTipsPage || false;
    },
  },
  watch: {
    isFollowedByMe() {
      this.followChanged = true;
      setTimeout(this.refreshTooltips, 500);
    }
  },
  updated() {
    this.showAllComments = this.data.showAllComments ?? this.showAllComments;
  },
  mounted() {
    this.checkAndRedirectToComment();
    this.parseDate();
    this.setAbsDate();
    this.spotlightComment();
    this.isBlockedCommentShown = this.isBlocked;
    this.$nextTick(lazyLoad);
    this.editContent = this.content;

    socket?.on('like-added', data => {
      if (data.postId === Number(this.WP.id)) {
        this.addLikeBySomeoneElse(data);
      }
    });
    socket?.on('like-removed', data => {
      if (data.postId === Number(this.WP.id)) {
        this.removeLikeBySomeoneElse(data);
      }
    });
  },
  methods: {
    setCommentSignatureError(errorMessage) {
      this.commentSignatureError = true;
      this.commentSignatureErrorMessage = errorMessage;
    },
    showBlockedComment(){
      let index = this.blockedUserIds.findIndex(id => id === this.authorId);
      if (index !== -1 ) {
        this.isBlockedCommentShown = false;
      }
    },
    checkAndRedirectToComment() {
      const redirectURL = window.location.href;
      const expectedURL = window.location.href.split('#')[0] + '#comment-' + this.id;
      const isRedirecting = redirectURL.includes('#comment-');
      const dashIndex = redirectURL.lastIndexOf('-');

      if (isRedirecting && dashIndex && redirectURL !== expectedURL) { // only for hidden bet comments
        const commentId = redirectURL.substring(dashIndex + 1);
        this.comments.forEach((comment) => {
          if (comment.comment_id === commentId) {
            this.showAllComments = true;
          }
        });
      }
    },
    spotlightComment() {
      let anchor = window.location.hash.substring(1);
      if (!anchor.startsWith('comment-')) {
        return;
      }
      let id = Number(anchor.substring(anchor.indexOf('-') + 1));
      if (id === this.id) {
        this.showSpotlight = true;
        setTimeout(() => {
          this.showSpotlight = false;
        }, 4000);
      }
    },
    parseDate() {
      const currentDate = this.DateTime.now();
      const commentDate = this.DateTime.fromSQL(this.date);

      const diff = commentDate.diff(currentDate, ['years', 'months', 'days', 'hours', 'minutes', 'seconds', 'milliseconds']);

      if (diff.months === 0 && diff.years === 0 && diff.days === 0 && diff.hours === 0 && diff.minutes === 0 && diff.seconds >= 0) {
        this.parsedDate = `przed chwilą`;
      } else if (diff.months === 0 && diff.years === 0 && diff.days === 0 && diff.hours === 0 && diff.minutes === 0) {
        this.parsedDate = `przed chwilą`;
      } else if (diff.months === 0 && diff.years === 0 && diff.days === 0 && diff.hours === 0) {
        this.parsedDate = `${-diff.minutes} min. temu`;
      } else if (diff.months === 0 && diff.years === 0 && diff.days === 0) {
        this.parsedDate = `${-diff.hours} godz. temu`;
      } else if (diff.days < 0 && diff.months === 0 && diff.years === 0) {
        this.parsedDate = `${-diff.days} ${(diff.days === 0 || diff.days === -1) ? 'dzień' : 'dni'} temu`;
      } else if (diff.months < 0 && diff.years === 0) {
        this.parsedDate = `${-diff.months} ${getPrefix(diff.months, ['miesiąc','miesiące','miesięcy'])} temu`;
      } else {
        this.parsedDate = `${-diff.years} ${getPrefix(diff.years, ['rok','lata','lat'])} temu`;
      }

      function getPrefix(diff, arr){
        if(diff === -1) return arr[0];
        else if(diff > -5 && diff < -1) return arr[1];
        else return arr[2];
      }

      setTimeout(() => {
        this.parseDate();
      }, 60000);
    },
    setAbsDate() {
      const betDate = this.DateTime.fromSQL(this.date);
      let year = '';
      if (betDate.year !== this.DateTime.now().year) {
        year = 'y ';
      }
      this.absDate = betDate.day + betDate.toFormat(` MMMM ${year}'o' HH:mm`);
    },
    toggleLike() {
      if (!this.isCommentApproved) {
        return;
      }
      this.animate= true;
      if (this.isLikedByMe) {
        this.animate= false;
        return this.removeLike();
      } else {
        return this.addLike();
      }
    },
    showAll() {
      this.showMore = true;
    },
    addLike() {
      axios
        .post(this.WP.ajaxUrl, {
          endpoint: 'api_add_comment_like',
          comment_id: this.id
        })
        .then(response => {
          if (response.data.success) {
            if (response.data.data.message !== 'error') {
              this.userStore.addLikedCommentId(this.id);
              this.likeCount++;
              socket?.emit('like-added', {
                commentId: this.id,
                parentId: Number(this.data.parent_id) !== 0 ? Number(this.data.parent_id) : this.id,
                postId: this.postId,
                userId: response.data.data.comment_like.user_id,
              });
              if (this.authorId.toString() === response.data.data.comment_like.user_id.toString()) {
                return;
              }
              if (this.authorId > 0) {
                const notificationData = {
                  recipientId: this.authorId,
                  comment_id: this.id.toString(),
                  post_id: this.postId.toString(),
                  sender_id: response.data.data.comment_like.user_id.toString(),
                  seen: '0',
                  created_at: DateTime.now().toFormat('yyyy-MM-dd HH:mm:ss'),
                  type: 'CommLike',
                  sender_avatar: this.WP.user.avatar,
                  sender_name: this.WP.user.name || false,
                  id: response.data.data.id
                };
                socket?.emit('notify-user', notificationData);
              }
            }
          }
      });
    },
    removeLike() {
      axios
        .post(this.WP.ajaxUrl, {
          endpoint: 'api_delete_comment_like',
          comment_id: this.id,
	        type: 'CommLike'
        })
        .then(response => {
          if (response.data.success) {
            if (response.data.data.message !== 'error') {
              this.userStore.removeLikedCommentId(this.id);
              this.likeCount--;
              socket?.emit('like-removed', {
                commentId: this.id,
                parentId: Number(this.data.parent_id) !== 0 ? Number(this.data.parent_id) : this.id,
                postId: this.postId,
                userId: this.WP.user.id,
                ip: this.userIP
              });
            }
          }
        });
    },
    addComment() {
      if (this.lastCommentTimestamp && this.DateTime.now().toSeconds() - this.lastCommentTimestamp < 10) {
        this.addInternalNotification(new Notice().setContent('Odczekaj chwilę, zanim dodasz kolejny komentarz'));
        return;
      }
      
      let commentContent = this.parseEmoji(this.answerContent);
      commentContent = this.removeUnicodeLeaveEmojis(commentContent);

      if (commentContent.replace(/\s/g, "").length < 1) {
        this.addInternalNotification(new Notice().setContent('Dodaj treść komentarza'));
        return;
      }

      const isSignatureOffensive = isPhraseOffensive(this.signature);

      if (this.signature.replace(/\s/g, "").length < 3 && !this.isLoggedIn()) {
        this.setCommentSignatureError(this.commentSignatureErrorMessages.too_short_signature);
      }

      if (this.signature.replace(/\s/g, "").length > 30 && !this.isLoggedIn()) {
        this.setCommentSignatureError(this.commentSignatureErrorMessages.too_long_signature);
      }

      if (isSignatureOffensive && !this.isLoggedIn()) {
        this.setCommentSignatureError(this.commentSignatureErrorMessages.offensive_language);
      }

      if (this.commentSignatureError) return;

      this.lastCommentTimestamp = this.DateTime.now().toSeconds();

      axios
        .post(this.WP.slowAjaxUrl, {
          endpoint: 'api_add_comment',
          content: commentContent.trim(),
          post_id: this.postId,
          signature: this.signature,
          parent_id: this.nestingLevel > 2 ? this.parentId : this.id,
					parent_type: this.type,
          bookie: this.bookie ? this.bookie : null,
          mentions: this.answerMentions,
        })
        .then(response => {
          if (response.data.success) {
	          if (!this.isBetFollowed) {
		          this.$emit('followPost');
	          }
            this.comments.push(response.data.data.comment);
            this.answerContent = '';
            this.isAnswerOpen = false;
            this.showAllComments = true;
						if (response.data.data.notification) {
							const notificationData = response.data.data.notification;
							const commentData = response.data.data.comment;
							for (let i = 0; i < notificationData.length; i++) {
								const notification = notificationData[i];
								const data =  {
									recipientId: +notification.recipient_id,
									comment_id: notification.comment_id.toString(),
									post_id: this.postId.toString(),
									sender_id: notification.sender_id.toString(),
									seen: '0',
									created_at: DateTime.now().toFormat('yyyy-MM-dd HH:mm:ss'),
									type: notification.type,
                  content: response.data.data.comment,
									sender_avatar: commentData.author_avatar,
									sender_name: commentData.author_name,
                  parent_author: notification.parent_author,
                  parent_type: notification.parent_type,
									id: notification.id,
								};
								socket?.emit('notify-user', data);
							}
						}
          }
          else {
            this.addInternalNotification(new Notice().setContent(response.data.data));
          }
        });
    },
    showOptionsModal() {
      const commentNode = document.getElementById(`comment-${this.id}`);
      const commentPosition = commentNode.getBoundingClientRect().top + window.pageYOffset;
      scrollTo(0, commentPosition - (this.WP.user.adminBar ? 120 : 100));
      this.isOptionsModalOpen = true;
      this.blockScrolling();
    },
    hideOptionsModal() {
      this.isOptionsModalOpen = false;
      this.unblockScrolling();
    },
    blockUser(isCancel = false) {
      if(!this.isLoggedIn()){
        this.openLoginModal();
        return;
      }
      axios
        .post(this.WP.ajaxUrl, {
          endpoint: 'api_block_user',
          blocked_user_id: this.authorId
        })
        .then(response => {
          if (response.data.success) {
            this.isBetOptionsModalOpen = false;
            this.$emit('blockUser', this.authorId);
            if(!isCancel){
              this.addInternalNotification(new Notice().setContent(response.data.data.message)
                  .setCancelAction(this.unblockUser.bind(this, true)));
            }
          }
          else{
            this.addInternalNotification(new Notice().setContent(response.data.data));
          }
        });
    },
    unblockUser(isCancel = false) {
      if(!this.isLoggedIn()){
        this.openLoginModal();
        return;
      }
      axios
        .post(this.WP.ajaxUrl, {
          endpoint: 'api_unblock_user',
          blocked_user_id: this.authorId
        })
        .then(response => {
          if (response.data.success) {
            this.$emit('unblockUser', this.authorId);
            if(!isCancel){
              this.addInternalNotification(new Notice().setContent(response.data.data.message)
                  .setCancelAction(this.blockUser.bind(this, true)));
            }
          }
          else{
            this.addInternalNotification(new Notice().setContent(response.data.data));
          }
        });
    },
    follow() {
      if(!this.isLoggedIn()){
        this.openLoginModal();
        return;
      }
      this.userStore.followUser(this.authorId);
    },
    unfollow() {
      if(!this.isLoggedIn()){
        this.openLoginModal();
        return;
      }
      this.userStore.unfollowUser(this.authorId);
    },
    resize() {
      const { textarea } = this.$refs;
      textarea.style.height = 'auto';
      textarea.style.height = textarea.scrollHeight + 'px';
    },
    changeUrl() {
      window.history.replaceState(null, '', window.location.href.split('#')[0] + '#comment-' + this.id);
    },
    toggleAnswer() {
      this.isAnswerOpen = !this.isAnswerOpen;

      if (this.isAnswerOpen) {
        setTimeout(() => {
          const { textarea } = this.$refs;
          if (textarea)
            textarea.focus();
        }, 200);
      }
    },
    addLikeBySomeoneElse(data) {
      if (data.commentId === this.id) {
        this.likeCount++;
      }
    },
    removeLikeBySomeoneElse(data) {
      if (data.commentId === this.id) {
        this.likeCount--;
      }
    },
    deleteComment() {
      axios
          .post(this.WP.slowAjaxUrl, {
            endpoint: 'api_delete_comment',
            id: this.id,
          })
          .then(response => {
            if (response.data.success) {
              this.addInternalNotification(new Notice().setContent(response.data.data.message +'. Odśwież stronę'));
              this.isDeleted = true;
            }
            else {
              this.addNotification(new Notice().setContent('Coś poszło nie tak spróbuj ponownie'));
            }
          });
    },
    pinCommentToAll() {
      axios
        .post(this.WP.ajaxUrl, {
          endpoint: 'api_pin_to_all',
          comment_id: this.id
        })
        .then(response => {
          if (response.data.success) {
            this.data.pinned_to_all = 1;
          }
        });
    },
    unpinCommentFromAll() {
      axios
        .post(this.WP.ajaxUrl, {
          endpoint: 'api_unpin_from_all',
          comment_id: this.id
        })
        .then(response => {
          if (response.data.success) {
            this.data.pinned_to_all = 0;
          }
        });
    },
    editComment() {
      this.editMode = true;
    },
    cancelEdit() {
      this.editMode = false;
      this.editContent = this.content;
    },
    saveEditComment() {
      this.axios.post(this.WP.ajaxUrl, {
        endpoint: 'api_edit_comment',
        comment_id: this.id,
        content: this.editContent
      }).then(resp => {
        if (resp.data.success) {
          this.data.content = this.editContent;
          this.editMode = false;
          this.addInternalNotification(new Notice().setContent('Pomyślnie edytowano komentarz'));
        }
      })
    },
    isSignedUser() {
      return Number(this.authorId) === 0;
    },
    showReportModal() {
      if(!this.isLoggedIn()){
        this.openLoginModal();
        return;
      }
      this.isReportModalOpen = true;
      setTimeout(() => {
        this.blockScrolling();
      }, 50);
    },
    hideReportModal() {
      this.isReportModalOpen = false;
      this.unblockScrolling();
    },
    handleTextareaInput(event) {
      this.resize();
      if (this.isMentionEnabled) {
        this.handleMentionInput(event);
      }
    },
    handleTextareaKeyup(event) {
      this.resize();
      if (this.isMentionEnabled) {
        this.handleMentionKeyup(event);
      }
    },
    handleTextareaKeydown(event) {
      if (this.isMentionEnabled && this.mentionSuggestions.isVisible) {
        this.handleMentionKeydown(event);
      }
    },
    handleMentionInput(event) {
      const textarea = event.target;
      const cursorPosition = this.mentions.getCaretPosition(textarea);
      const mentionInfo = this.mentions.getMentionTriggerInfo(textarea, cursorPosition);
      
      if (mentionInfo) {
        this.mentionSuggestions.mentionInfo = mentionInfo;
        this.mentionSuggestions.searchQuery = mentionInfo.searchQuery;
        this.showMentionSuggestions(textarea);
      } else {
        this.closeMentionSuggestions();
      }
    },
    handleMentionKeyup(event) {
      if (event.key === 'Escape') {
        this.closeMentionSuggestions();
      }
    },
    handleMentionKeydown(event) {
      if (!this.mentionSuggestions.isVisible) return;
      
      const suggestionComponent = this.$refs.mentionSuggestions;
      
      switch (event.key) {
        case 'ArrowDown':
          event.preventDefault();
          if (suggestionComponent) {
            suggestionComponent.navigateDown();
          }
          break;
        case 'ArrowUp':
          event.preventDefault();
          if (suggestionComponent) {
            suggestionComponent.navigateUp();
          }
          break;
        case 'Enter':
        case 'Tab':
          event.preventDefault();
          if (suggestionComponent) {
            suggestionComponent.selectCurrentUser();
          }
          break;
        case 'Escape':
          event.preventDefault();
          this.closeMentionSuggestions();
          break;
      }
    },
    showMentionSuggestions() {
      this.mentionSuggestions.isEditMode = false;
      this.mentionSuggestions.isVisible = true;
    },
    closeMentionSuggestions() {
      this.mentionSuggestions.isVisible = false;
      this.mentionSuggestions.searchQuery = '';
      this.mentionSuggestions.mentionInfo = null;
      this.mentionSuggestions.isEditMode = false;
    },
    handleMentionSelect(user) {
      if (!this.mentionSuggestions.mentionInfo) return;
      
      const textarea = this.$refs.textarea;
      if (textarea) {
        const { newText, id } = this.mentions.insertMention(textarea, this.mentionSuggestions.mentionInfo, user);
        this.answerContent = newText;
        this.answerMentions.push(id);
      }
      
      this.closeMentionSuggestions();
      
      this.$nextTick(() => {
        if (textarea) {
          textarea.focus();
        }
      });
    },
    handleEditMentionInput(event) {
      const textarea = event.target;
      const cursorPosition = this.mentions.getCaretPosition(textarea);
      const mentionInfo = this.mentions.getMentionTriggerInfo(textarea, cursorPosition);
      
      if (mentionInfo) {
        this.mentionSuggestions.mentionInfo = mentionInfo;
        this.mentionSuggestions.searchQuery = mentionInfo.searchQuery;
        this.mentionSuggestions.isEditMode = true;
        this.showEditMentionSuggestions(textarea);
      } else {
        this.closeMentionSuggestions();
      }
    },
    handleEditMentionKeyup(event) {
      if (event.key === 'Escape') {
        this.closeMentionSuggestions();
      }
    },
    showEditMentionSuggestions(textarea) {
      this.mentionSuggestions.isVisible = true;
    },
    handleEditMentionSelect(user) {
      if (!this.mentionSuggestions.mentionInfo) return;
      
      const textarea = this.$refs.editTextarea;
      if (textarea) {
        const { newText, id } = this.mentions.insertMention(textarea, this.mentionSuggestions.mentionInfo, user);
        this.editContent = newText;
        this.editMentions.push(id);
      }
      
      this.closeMentionSuggestions();
      
      this.$nextTick(() => {
        if (textarea) {
          textarea.focus();
        }
      });
    }
  }
};
</script>

<style lang="scss">
.slide-enter-active,
.slide-leave-active {
  transition: all 0.3s ease-out;
  max-height: 46px;
}

.slideguest-enter-active,
.slideguest-leave-active {
  transition: all 0.3s ease-out;
  max-height: 95px;
}

.slideguest-enter-from,
.slideguest-leave-to {
  max-height: 0;
  opacity: 0;
}

.slide-enter-from,
.slide-leave-to {
  max-height: 0;
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s ease-out;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
